import { ensure, ensureArray, stringType, TType } from "types";

import { ILanguage } from "@/data/languages";
import { IRole, roleType } from "@/data/roles";

export interface ISuggestedProfileData {
  locations: string[];
  roles: IRole[];
  languages: ILanguage[];
}

export const configSugggestedProfileDataType: TType<ISuggestedProfileData> = {
  locations: ensureArray(stringType(null)),
  roles: ensureArray(roleType),
  languages: ensureArray(stringType(null)),
};

export const suggestedProfileDataType = ensure(configSugggestedProfileDataType);
